import { createMemo, Show } from "solid-js";
import { useBillingContext } from "../context/billing-provider";
import { BillingStatusBanner } from "./BillingStatusBanner";

const DEGRADED_STATUSES = new Set(["past_due", "grace_period", "unpaid"]);

export const DunningBanner = () => {
  const { billingStatusContract } = useBillingContext();

  const degradedStatus = createMemo(() => {
    const contract = billingStatusContract();
    if (!contract) return undefined;
    if (!DEGRADED_STATUSES.has(contract.billing_status)) return undefined;
    return contract;
  });

  return (
    <Show when={degradedStatus()}>
      {(status) => (
        <div class="px-4 pt-4">
          <BillingStatusBanner status={status()} />
        </div>
      )}
    </Show>
  );
};
